import React from "react";
import "./FooterBottom.scss";
import Wrapper from "../../Common/Wrapper";

const FooterBottom = ({ themeOptions }) => {
    const { footer_menu } = themeOptions;

    return (
        <div className="footer--bottom">
            <Wrapper>
                <div className="footer--bottom__inside">
                    {/* Wyświetlanie elementów menu */}
                    <div className="footer--bottom__inside--menu">
                        {footer_menu && footer_menu.length > 0 && (
                            <ul className="footer-menu">
                                {footer_menu.map((item, index) => {
                                    const { title, url, target } = item.menu_element;
                                    return (
                                        <li key={index} className="footer-menu__item">
                                            <a
                                                href={url}
                                                target={target || "_self"}
                                                rel={target === "_blank" ? "noopener noreferrer" : undefined}
                                                className="footer-menu__link"
                                            >
                                                {title}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>

                    {/* Sekcja z prawami autorskimi */}
                    <div className="footer--bottom__inside--copy">
                        <p>© {new Date().getFullYear()} Site-Art Wszelkie prawa zastrzeżone.</p>
                    </div>
                </div>
            </Wrapper>
        </div>
    );
};

export default FooterBottom;
